import Icons from "components/Icons";
import React from "react";
import { connect } from "react-redux";
import { DateTime } from "luxon";
import { Popconfirm } from "antd";

import UserPlaceholder from "assets/images/placeholders/user2x.jpg";
import strings from "utils/strings";
import "./styles.scss";
import { push } from "connected-react-router";

class AppointmentCard extends React.Component<any, any> {
	render() {
		const {
			appointment,
			simple = false,
			empty = false,
			onClick,
			language,
			noButton = false,
			onCancel,
			onReschedule,
			isPsychologist = false,
			dispatch,
			noPatients = false,
			showReport = false
		} = this.props;

		const photo = isPsychologist
			? appointment?.user?.photo || UserPlaceholder
			: appointment?.psychologist?.photo || UserPlaceholder;
		const name = isPsychologist
			? appointment?.user?.name
			: appointment?.psychologist?.externalName || appointment?.psychologist?.name;

		const buttons = [];
		if (isPsychologist && !noButton && !noPatients) {
			buttons.push(
				<button
					key="check_patient"
					className="AppointmentOption --primary"
					onClick={() => dispatch(push(`/patients/${appointment?.user?._id}`))}
				>
					{strings.appointments.checkPatient}
				</button>
			);
		} else if ((isPsychologist && noButton) || (isPsychologist && showReport && !appointment?.finished)) {
			buttons.push(
				<button
					key="patiente_report"
					className="AppointmentOption --primary"
					onClick={() => dispatch(push(`/appointments/${appointment?._id}/report`))}
				>
					{strings.appointments.report}
				</button>
			);
		}

		const showButton = DateTime.utc() >= DateTime.fromISO(appointment?.startDate).minus({ minutes: 30 });

		return (
			<div className={`AppointmentCardWrapper${simple ? " --card-simple" : ""}`}>
				<div className="AppointmentDetailsWrapper">
					<div className="AppointmentDetails">
						{!empty && (
							<div
								onClick={() => {
									if (isPsychologist) {
										dispatch(push(`/patients/${appointment?.user?._id}`));
									}
								}}
								className={`PsychologistAvatar${isPsychologist ? " --clickable" : ""}`}
							>
								<img src={photo} alt="psychologist avatar" />
							</div>
						)}
						<div className="PsychologistDetails">
							<p
								onClick={() => {
									if (isPsychologist) {
										dispatch(push(`/patients/${appointment?.user?._id}`));
									}
								}}
								className={isPsychologist ? " --clickable" : ""}
							>
								{name}
							</p>
							<div className="CardRow">
								<div className="CardRowIconWrapper">
									<Icons.Calendar smaller color="blue" />
									<p>
										{DateTime.fromISO(appointment?.startDate)
											.setLocale(language)
											.toFormat("dd LLLL yyyy")}
									</p>
								</div>
								<div className="CardRowIconWrapper">
									<Icons.Clock color="blue" />
									<p>{DateTime.fromISO(appointment?.startDate).toFormat("HH:mm")}H</p>
								</div>
							</div>
						</div>
					</div>
					{!noButton && empty && (
						<div className="AppointmentVideoContainer">
							<button
								onClick={() => {
									if (typeof onClick === "function") {
										onClick();
									}
								}}
								className="VideoIconWrapper"
							>
								{<Icons.Arrow />}
							</button>
						</div>
					)}
					{!noButton && !empty && showButton && (
						<div className="AppointmentVideoContainer">
							<button
								onClick={() => {
									if (typeof onClick === "function") {
										onClick();
									}
								}}
								className="VideoIconWrapper"
							>
								{<Icons.Camera />}
							</button>
						</div>
					)}
					{(noButton || (!noButton && !empty && !showButton)) && (
						<div className="AppointmentVideoContainer" />
					)}
				</div>
				<div className="AppointmentOptions">
					{isPsychologist ? (
						buttons
					) : (
						<React.Fragment>
							<Popconfirm
								placement="top"
								title={strings.appointments.cancelAppointment}
								onConfirm={() => {
									if (typeof onCancel === "function") {
										onCancel();
									}
								}}
								okText={strings.generic.yes}
								cancelText={strings.generic.no}
							>
								<button className="AppointmentOption">{strings.appointments.cancel}</button>
							</Popconfirm>
							<button
								className="AppointmentOption --primary"
								onClick={() => {
									if (typeof onReschedule === "function") {
										onReschedule();
									}
								}}
							>
								{strings.appointments.reschedule}
							</button>
						</React.Fragment>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language
});

export default connect(mapStateToProps)(AppointmentCard);
